import { render } from "./SupportCard.vue?vue&type=template&id=b6d09764&scoped=true"
import script from "./SupportCard.vue?vue&type=script&lang=js"
export * from "./SupportCard.vue?vue&type=script&lang=js"

import "./SupportCard.vue?vue&type=style&index=0&id=b6d09764&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d09764"]])

export default __exports__